/**
 * INSUMO QUE SE PROCESA AL LLEGAR (AL-T1, mision INVENTARIO-PORCIONADO-ALERTAS-V1-001; contrato nexo-api 654, Ares #37600).
 *
 * El dueno marca el insumo (ej. camaron que llega entero y se limpia y porciona). Cuando una linea de factura de Compras
 * casa con un insumo marcado, el detalle lo dice para que alguien lo procese y lo registre con un movimiento de inventario.
 *   escritura: PATCH .../insumos/{insumoId:guid}/config { requiereProcesamiento } (camelCase; los demas campos del mismo
 *              DTO van en snake_case con JsonPropertyName, InsumoConfigPatchRequestDto)
 *   lectura:   listado de insumos -> requiereProcesamiento; detalle de factura -> item.insumoRequiereProcesamiento y
 *              candidato.requiereProcesamiento
 * Sin tabla de alertas: el aviso vive en la respuesta del match. El escritorio no cambia (D #37598).
 *
 * Sin DOM: lo prueba scripts/check-requiere-procesamiento.mjs.
 */

export const AVISO_EN_COMPRAS = 'Este insumo se procesa al llegar: cuando lo limpien o porcionen, registren lo procesado con un movimiento de inventario.';

export const AYUDA_DE_LA_CASILLA = 'Márcalo si este insumo llega en bruto y hay que limpiarlo o porcionarlo (ej. camarón entero). Cuando entre en una factura de Compras, el detalle lo avisará.';

/** La marca del insumo, venga en camelCase o snake_case; ausente = no marcado. */
export function marcaDelInsumo(ins) {
  return (ins?.requiereProcesamiento ?? ins?.requiere_procesamiento) === true;
}

/** El aviso de una linea ya adaptada por ComprasApiClient: solo si el insumo casado esta marcado. */
export function avisoDelItem(item) {
  return item?.insumo_requiere_procesamiento === true ? AVISO_EN_COMPRAS : null;
}

/**
 * La parte del cuerpo del PATCH de config que le toca a esta marca: SOLO si la casilla cambio respecto de lo leido al
 * abrir el modal. Q #37665: la lista que lee el modal puede llegar hasta 30 s vieja (cache de la API con otra clave que la
 * que borra el PATCH); mandar siempre la marca haria que guardar el umbral escriba false y borre una marca recien puesta.
 * La API trata omitido = no tocar.
 */
export function cuerpoDeLaMarca(marcado, marcadoAlAbrir) {
  const ahora = marcado === true;
  return ahora === (marcadoAlAbrir === true) ? {} : { requiereProcesamiento: ahora };
}
